import { Controller } from "@hotwired/stimulus";

// When landing on Revenue page with ?goal= param, open the goal modal.
// We call the modal controller's open() directly instead of programmatically clicking the trigger.
// Programmatic clicks cause railsui-modal's useClickOutside to fire (the trigger is "outside" the
// modal content), and its whitelist checks for "click->modal#open" but we use "railsui-modal#open",
// so the click would incorrectly close the modal immediately after opening.
//
// stopClickPropagation: prevent the opening click from bubbling to document so useClickOutside
// doesn't wrongly close the modal (the trigger is "outside" the modal content).
export default class extends Controller {
  connect() {
    const params = new URLSearchParams(window.location.search);
    const goal = params.get("goal");
    if (goal) {
      requestAnimationFrame(() => this.openModal());
    }
  }

  openModal() {
    const modalEl = this.element.querySelector("[data-controller~='railsui-modal']");
    if (!modalEl) return;
    const controller = this.application.getControllerForElementAndIdentifier(modalEl, "railsui-modal");
    if (controller && typeof controller.open === "function") {
      controller.open({ preventDefault: () => {} });
    }
  }

  stopClickPropagation(event) {
    event.stopPropagation();
  }
}
